import { render } from "./GuideSection.vue?vue&type=template&id=fd47d42e&scoped=true"
import script from "./GuideSection.vue?vue&type=script&lang=js"
export * from "./GuideSection.vue?vue&type=script&lang=js"

import "./GuideSection.vue?vue&type=style&index=0&id=fd47d42e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd47d42e"]])

export default __exports__